export function initAdvantagesSlider() {
  let advantagesSwiperEl = document.querySelector('.advantages__swiper');
  let isAdvantagesInited = false;

  function buildAdvantagesParams() {
    const w = window.innerWidth;
    return {
      loop: false,
      slidesPerView: 1,
      centeredSlides: w < 480,
      spaceBetween: 16,
      watchSlidesProgress: true,
      observeParents: true,
      observer: true,
      resizeObserver: true,
      speed: 450,
      breakpoints: {
        0: { slidesPerView: 1.3, centeredSlides: true },
        768: { slidesPerView: 2, centeredSlides: false },
        900: { slidesPerView: 3 },
      },
      navigation: { prevEl: '.advantages__prev', nextEl: '.advantages__next' },
    };
  }

  function updateAdvantagesNav() {
    if (!advantagesSwiperEl || !advantagesSwiperEl.swiper) return;
    const swiper = advantagesSwiperEl.swiper;
    const prevBtn = document.querySelector('.advantages__prev');
    const nextBtn = document.querySelector('.advantages__next');
    if (!prevBtn || !nextBtn) return;
    const isWide = window.innerWidth >= 900;
    // Accessibility: disable buttons when slider is not active
    if (isWide) {
      prevBtn.setAttribute('aria-disabled', 'true');
      prevBtn.setAttribute('tabindex', '-1');
      nextBtn.setAttribute('aria-disabled', 'true');
      nextBtn.setAttribute('tabindex', '-1');
    } else {
      prevBtn.removeAttribute('aria-disabled');
      prevBtn.setAttribute('tabindex', '0');
      nextBtn.removeAttribute('aria-disabled');
      nextBtn.setAttribute('tabindex', '0');
      prevBtn.classList.toggle('is-hidden', swiper.isBeginning);
      nextBtn.classList.toggle('is-hidden', swiper.isEnd);
    }
  }

  function equalizeAdvantagesCardHeights() {
    if (window.innerWidth >= 1200) {
      const advantagesWrapper = document.querySelector('.advantages__wrapper');
      advantagesWrapper?.querySelectorAll('.adv-card').forEach(c => {
        c.style.height = '';
      });
      return;
    }
    const advantagesWrapper = document.querySelector('.advantages__wrapper');
    if (!advantagesWrapper) return;
    const wrappers = advantagesWrapper.querySelectorAll('.adv-cards__wrapper');
    if (!wrappers.length) return;
    wrappers.forEach(w => {
      w.querySelectorAll('.adv-card').forEach(c => (c.style.height = ''));
    });
    let maxFirst = 0;
    let maxSecond = 0;
    wrappers.forEach(w => {
      const cards = Array.from(w.querySelectorAll('.adv-card:not(.adv-cards-stats)'));
      if (cards[0]) maxFirst = Math.max(maxFirst, cards[0].scrollHeight);
      if (cards[1]) maxSecond = Math.max(maxSecond, cards[1].scrollHeight);
    });
    wrappers.forEach(w => {
      const cards = Array.from(w.querySelectorAll('.adv-card:not(.adv-cards-stats)'));
      if (cards[0]) cards[0].style.height = maxFirst + 'px';
      if (cards[1]) cards[1].style.height = maxSecond + 'px';
    });
    const sampleWrapper = wrappers[0];
    let gap = 16;
    if (sampleWrapper) {
      const cs = getComputedStyle(sampleWrapper);
      const g = parseInt(cs.rowGap || cs.gap, 10);
      if (!isNaN(g)) gap = g;
    }
    const statsCard = advantagesWrapper.querySelector('.adv-cards-stats');
    if (statsCard) {
      statsCard.style.height = maxFirst + gap + maxSecond + 'px';
    }
  }

  function handleResize() {
    const viewportWide = window.innerWidth >= 1200;
    if (viewportWide) {
      if (isAdvantagesInited && advantagesSwiperEl.swiper) {
        advantagesSwiperEl.swiper.destroy(true, true);
        isAdvantagesInited = false;
      }
      equalizeAdvantagesCardHeights();
      return;
    }
    const params = buildAdvantagesParams();
    if (isAdvantagesInited && advantagesSwiperEl.swiper) {
      advantagesSwiperEl.swiper.destroy(true, true);
      isAdvantagesInited = false;
    }
    Object.assign(advantagesSwiperEl, params);
    advantagesSwiperEl.initialize();
    isAdvantagesInited = true;
    advantagesSwiperEl.swiper.on('slideChange', updateAdvantagesNav);
    updateAdvantagesNav();
    requestAnimationFrame(() => equalizeAdvantagesCardHeights());
  }

  handleResize();
  window.addEventListener('resize', handleResize);
  window.addEventListener('load', equalizeAdvantagesCardHeights);
}
